export default __webpack_public_path__ + "static/cta-dont-c06ad891d691d0b63e5c8fcc4d8db8925a1670e6cdd63bacd4af560ea3c9176f.png";